// ExcelUploadComponent.js
import React from "react";
import styled from "styled-components";
import InputBox from "../elements/inputBox";
import { useNavigate } from "react-router-dom";
import PrimaryButton from "../elements/button";
import { useSelector } from "react-redux";
import Loader from "../Loader/Loader";
import { RiFileExcel2Line } from "react-icons/ri";

const StyledContainer = styled.div`
	max-width: 400px;
	margin: auto;
	padding: 20px;
	border: 1px solid #ccc;
	border-radius: 5px;
	background-color: #ffffff;
	display: flex;
	flex-direction: column;
`;

const StyledInputContainer = styled.div`
	margin-bottom: 15px;

	label {
		display: block;
		margin-bottom: 5px;
	}

	input {
		width: 100%;
		padding: 8px;
		border: 1px solid #ccc;
		border-radius: 3px;
	}
`;

const StyledFileInputContainer = styled(StyledInputContainer)`
	display: flex;
	align-items: center;

	input {
		flex: 1;
		margin-right: 10px;
	}
`;

const StyledButton = styled.button`
	padding: 10px;
	border: none;
	border-radius: 5px;
	cursor: pointer;
	background: linear-gradient(180deg, #ff9250 0%, #f37021 100%);
	box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
	color: #ffffff;

	&:hover {
		background-color: #45a049;
	}
`;

const CreateAuction = ({
	handleChange,
	handleSubmitcreateAuction,
	auction_name,
	start_date,
	end_date,
	errors,
}) => {
	const navigate = useNavigate();
	const viewAuctions = () => {
		navigate("/auctionUploadedList");
	};
	const createAuctionObj = useSelector((state) => state.createAuctionReducer);
	const { loading } = createAuctionObj;

	return (
		<StyledContainer>
			<div
				style={{
					display: "flex",
					justifyContent: "space-between",
					alignItems: "center",
					marginBottom: "10px",
				}}
			>
				<h2 style={{ textAlign: "center" }}>Create Auction </h2>
				<PrimaryButton onClick={viewAuctions}>View Auctions</PrimaryButton>
			</div>
			<InputBox
				type="text"
				label="Auction Name"
				name="auction_name"
				id="auction_name"
				handleChange={handleChange}
				value={auction_name}
				errors={errors}
			/>
			<InputBox
				type="date"
				min={new Date().toISOString().split("T")[0]}
				label="Start Date"
				name="start_date"
				id="start_date"
				handleChange={handleChange}
				value={start_date}
				errors={errors}
			/>
			<InputBox
				type="date"
				label="End Date"
				name="end_date"
				id="end_date"
				handleChange={handleChange}
				disabled={start_date === "" ? true : false}
				min={start_date}
				value={end_date}
				errors={errors}
			/>
			<InputBox
				type="file"
				//accept=".xlsx, .xls, .csv"
				accept=".xlsx, .xls"
				label="Upload Excel"
				name="excel_file"
				id="excel_file"
				handleChange={handleChange}
				errors={errors}
			/>
			<div
				style={{
					marginBottom: "15px",
					display: "flex",
					alignItems: "center",
					gap: "5px",
				}}
			>
				<label>Download Template</label>
				<a
					href="https://amk-internal-tools-v2.s3.us-east-2.amazonaws.com/production/AuctionPortalFE/auctionTemplate.xlsx"
					target="_blank"
					rel="noreferrer"
					style={{ textDecoration: "none", fontSize: "14px" }}
				>
					<button
						style={{
							padding: "5px",
							borderRadius: "4px",
							background: "#FFF4E2",
							color: "#F37021",
						}}
					>
						<RiFileExcel2Line style={{ height: "24px", width: "24px" }} />
					</button>
				</a>
			</div>
			{loading ? (
				<Loader />
			) : (
				<StyledButton onClick={handleSubmitcreateAuction}>Submit</StyledButton>
			)}
		</StyledContainer>
	);
};

export default CreateAuction;
